import { Svg } from 'components/svg'
import type { IconType } from 'models'

export const IconTwitter: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 31 31">
    <path
      fill="currentColor"
      d="M16.684 14.0437L21.8986 8.11279H20.6634L16.1336 13.2615L12.5184 8.11279H8.34766L13.8157 15.8992L8.34766 22.1179H9.58291L14.3634 16.6796L18.1821 22.1179H22.3528M10.0287 9.02424H11.9264L20.6624 21.2513H18.7642"
    />
  </Svg>
)
